
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Source de données',
	'dataSourceId': 'ID',
	'dataSourceType': 'Type',
	'dataSourceName': 'Nom',
	'dataSourcePath': 'Chemin d\'accès',
	'showInfoForAll': 'Afficher la durée de toutes les visualisations',
	'hideInfoForAll': 'Masquer la durée de toutes les visualisations',
	'showPerformanceDetails': 'Réexécuter tous les widgets pour inclure les détails de performance',
	'slotMappingField': 'Mappages d\'attribut',
	'slotDataMapping': 'Mappage',
	'slotID': 'ID',
	'slotCaption': 'Légende',
	'slotMandatory': 'Obligatoire',
	'slotIsMandatory': 'Oui',
	'slotIsNotMandatory': 'Non',
	'infoNotAvailable': 'Non disponible',
	'performanceSection': 'Performances',
	'durationField': 'Durée',
	'singleQueryTime': 'Requête de serveur (ms)',
	'multipleQueryTime': 'Requête de serveur %{name} (ms)',
	'liveWidgetTotalTime': 'Total (ms)',
	'renderTimeNotAvailable': 'Non disponible',
	'renderInProgress': '(en cours)',
	'interactToTriggerQuery': 'Interagir avec le widget pour déclencher une requête',
	'fetchQuery': 'Extraire la requête',
	'showSQLMDX': 'Afficher SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Informations sur la requête',
	'queryInfoNotAvailable': 'Informations sur la requête indisponibles',
	'query': 'Requête',
	'copy': 'Copier',
	'close': 'Fermer'
});
